<template>
  <!--<div>-->
    <!--<div class="ui form">-->
      <!--<div class="field">-->
        <!--<label v-if="!options.hideLabel" >{{label}}</label>-->
      <!--</div>-->
    <!--</div>-->
    <el-date-picker style="width:100%"
      :value="getDateTypeValue"
      @input="setValue(+$event)"
      :readonly="property.readonly"
      :type="property.format=='date-time'?'datetime':'date'"
      :placeholder="placeholder">
    </el-date-picker>
  <!--</div>-->
</template>

<script>

   import singleControlMixin from './singleControlMixin'

    export default {
      name:"el-date-time-picker-control",
      mixins: [singleControlMixin],
      computed:{
        getDateTypeValue(){
          return this.getValue?new Date(this.getValue):null;
        }
      },

    }
</script>

<style scoped>

</style>
